import React from 'react';
import { Helmet } from 'react-helmet-async';
import FeaturePageTemplate from './FeaturePageTemplate';
import { Box, Typography, Paper, Grid, List, ListItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

const GorevTakibi: React.FC = () => {
  const { t } = useTranslation();
  const translatedFeatures = t('gorevTakibi.features', { returnObjects: true });
  const features: string[] = Array.isArray(translatedFeatures) ? translatedFeatures : [];

  return (
    <FeaturePageTemplate title={t('gorevTakibi.pageTitle')}>
      <Helmet>
        <title>{t('gorevTakibi.meta.title')}</title>
        <meta 
          name="description" 
          content={t('gorevTakibi.meta.description')} 
        />
        <meta 
          name="keywords" 
          content={t('gorevTakibi.meta.keywords')} 
        />
      </Helmet>
      
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Box
            component="img"
            src="/assets/gorev_takibi_ekran.png"
            alt={t('gorevTakibi.imageAlt')}
            sx={{
              width: '100%',
              maxHeight: 400,
              objectFit: 'contain',
              borderRadius: 2,
              mb: 3,
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
            }}
          />
        </Grid>
        
        <Grid item xs={12}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              backgroundColor: 'rgba(255, 255, 255, 0.1)', 
              backdropFilter: 'blur(10px)',
              borderRadius: 2
            }}
          >
            <Typography variant="h5" gutterBottom sx={{ color: 'white', fontWeight: 600, mb: 2 }}>
              {t('gorevTakibi.sectionTitle')}
            </Typography>
            
            <Typography variant="body1" paragraph sx={{ color: 'white', mb: 4 }}>
              {t('gorevTakibi.sectionDescription')}
            </Typography>

            <List>
              {features.map((feature, index) => (
                <ListItem key={index} sx={{ py: 0.5 }}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <CheckCircleOutlineIcon sx={{ color: '#4caf50' }} />
                  </ListItemIcon>
                  <ListItemText 
                    primary={feature} 
                    primaryTypographyProps={{ color: 'white' }} 
                  />
                </ListItem>
              ))}
            </List>

            <Typography variant="body1" paragraph sx={{ color: 'white', mt: 3 }}>
              {t('gorevTakibi.footer.p1')}
            </Typography>

            <Typography variant="body1" sx={{ color: 'white', fontWeight: 500, mt: 2 }}>
              {t('gorevTakibi.footer.p2')}
            </Typography>
            
            <Divider sx={{ my: 3, backgroundColor: 'rgba(255, 255, 255, 0.2)' }} />
            
            <Box sx={{ 
              p: 2, 
              borderLeft: '4px solid #4caf50', 
              backgroundColor: 'rgba(76, 175, 80, 0.1)', 
              borderRadius: '0 8px 8px 0',
              mt: 2 
            }}>
              <Typography variant="body1" sx={{ color: 'white', fontWeight: 500 }}>
                {t('gorevTakibi.footer.p3_security')}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </FeaturePageTemplate>
  );
};

export default GorevTakibi; 